import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inheritsLoose from "@babel/runtime/helpers/esm/inheritsLoose";
var _DarkTheme5_;
import { markAsDarkTheme, createTheme, markThemeVersion } from "../../../lib/theming/ThemeHelpers";
import { BasicTheme, BasicThemeClassForExtension } from "../BasicTheme";
export var DarkTheme5_0 = createTheme({
  themeClass: (_DarkTheme5_ = /*#__PURE__*/function (_BasicThemeClassForEx) {
    function DarkTheme5_0() {
      return _BasicThemeClassForEx.apply(this, arguments) || this;
    }
    _inheritsLoose(DarkTheme5_0, _BasicThemeClassForEx);
    return _createClass(DarkTheme5_0, null, [{
      key: "errorMain",
      get: function get() {
        return this.red;
      }
    }, {
      key: "borderColorError",
      get: function get() {
        return this.errorMain;
      }
    }, {
      key: "linkSuccessActiveColor",
      get: function get() {
        return this.green;
      }
    }, {
      key: "linkDangerColor",
      get: function get() {
        return this.errorText;
      }
    }, {
      key: "linkDangerActiveColor",
      get: function get() {
        return '#ED3F3F';
      }
    }, {
      key: "linkDisabledColor",
      get: function get() {
        return this.textColorDisabled;
      }
      //#endregion Link
      //#region Button
    }, {
      key: "btnDefaultHoverBorderColor",
      get: function get() {
        return this.borderColorGrayLight;
      }
    }, {
      key: "btnDefaultActiveBorderColor",
      get: function get() {
        return this.borderColorGrayLight;
      }
    }, {
      key: "btnSuccessBg",
      get:
      // success
      function get() {
        return this.green;
      }
    }, {
      key: "btnSuccessBorderColor",
      get: function get() {
        return this.btnSuccessBg;
      }
    }, {
      key: "btnSuccessTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "btnSuccessHoverBorderColor",
      get: function get() {
        return this.btnSuccessHoverBg;
      }
    }, {
      key: "btnSuccessActiveBg",
      get: function get() {
        return this.greenDark;
      }
    }, {
      key: "btnSuccessActiveBorderColor",
      get: function get() {
        return this.btnSuccessActiveBg;
      }

      // primary
    }, {
      key: "btnDangerBg",
      get:
      // danger
      function get() {
        return this.errorMain;
      }
    }, {
      key: "btnDangerBorderColor",
      get: function get() {
        return this.btnDangerBg;
      }
    }, {
      key: "btnDangerHoverBorderColor",
      get: function get() {
        return this.btnDangerHoverBg;
      }
    }, {
      key: "btnDangerTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "btnDangerActiveBorderColor",
      get: function get() {
        return this.btnDangerActiveBg;
      }

      // pay
    }, {
      key: "btnPayBorderColor",
      get: function get() {
        return this.btnPayBg;
      }
    }, {
      key: "btnPayHoverBorderColor",
      get: function get() {
        return this.btnPayHoverBg;
      }
    }, {
      key: "btnPayActiveBorderColor",
      get: function get() {
        return this.btnPayActiveBg;
      }

      // backless
    }, {
      key: "btnErrorSecondary",
      get: function get() {
        return this.errorSecondary;
      }

      // disabled
    }, {
      key: "btnDisabledTextColor",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "modalFooterTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "modalBodyTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "modalFixedPanelShadow",
      get: function get() {
        return this.fixedPanelShadow;
      }
    }, {
      key: "modalFixedHeaderBg",
      get: function get() {
        return this.modalBg;
      }
    }, {
      key: "sidePageBodyTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "sidePageFooterTextColor",
      get: function get() {
        return this.textColorDefault;
      }
    }, {
      key: "sidePageFixedPanelShadow",
      get: function get() {
        return this.fixedPanelShadow;
      }
      //#endregion SidePage

      //#region Select
    }, {
      key: "selectPlaceholderColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "selectMenuArrowColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
      //#endregion Select
      //#region Calendar
    }, {
      key: "calendarCellWeekendColor",
      get: function get() {
        return this.errorText;
      }
    }, {
      key: "pagingForwardLinkDisabledColor",
      get: function get() {
        return this.linkDisabledColor;
      }
      //#endregion Paging
      //#region Toast
    }, {
      key: "menuBgDefault",
      get:
      //#endregion Tab, Tabs
      //#region Menu
      function get() {
        return this.bgSecondary;
      }
      // menuItem
    }, {
      key: "menuItemDisabledColor",
      get: function get() {
        return this.textColorDisabled;
      }
      // menuHeader
    }, {
      key: "menuHeaderColor",
      get: function get() {
        return this.gray;
      }
      // menuFooter
    }, {
      key: "menuFooterColor",
      get: function get() {
        return this.menuHeaderColor;
      }
      //menuSeparator
    }, {
      key: "toggleContainerBgCheckedHover",
      get:
      // checked :hover
      function get() {
        return this.toggleContainerBgHover;
      }
    }, {
      key: "toggleBgDisabled",
      get:
      // disabled
      function get() {
        return this.bgDisabled;
      }
    }, {
      key: "tokenTextColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "inputBorderTopColor",
      get: function get() {
        return this.inputBorderColor;
      }
    }, {
      key: "inputFocusShadow",
      get: function get() {
        return "0 0 0 1px " + this.inputBorderColorFocus;
      }
    }, {
      key: "inputBorderColorError",
      get: function get() {
        return this.borderColorError;
      }
    }, {
      key: "inputTextColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "inputIconColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "inputPlaceholderColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "textareaBg",
      get:
      //#endregion GlobalLoader
      //#region TextArea
      function get() {
        return this.inputBg;
      }
    }, {
      key: "textareaBorderColor",
      get: function get() {
        return this.inputBorderColor;
      }
    }, {
      key: "textareaTextColorDisabled",
      get: function get() {
        return this.inputTextColorDisabled;
      }
    }, {
      key: "textareaPlaceholderColorDisabled",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "textareaBorderTopColor",
      get: function get() {
        return this.textareaBorderColor;
      }
    }, {
      key: "textareaDisabledBorderColor",
      get: function get() {
        return this.inputDisabledBorderColor;
      }
    }, {
      key: "textareaBorderColorFocus",
      get: function get() {
        return this.inputBorderColorFocus;
      }
      //#endregion TextArea
      //#region PasswordInput
    }, {
      key: "passwordInputVisibilityIconColor",
      get: function get() {
        return this.gray;
      }
    }, {
      key: "passwordInputVisibilityIconHoverColor",
      get: function get() {
        return this.textColorDefault;
      }
      //#endregion PasswordInput
      //#region Radio
    }, {
      key: "checkboxShadow",
      get: function get() {
        return "0 0 0 " + this.checkboxBorderWidth + " rgba(255, 255, 255, 0.32)";
      }
    }, {
      key: "checkboxShadowHover",
      get: function get() {
        return this.checkboxShadow;
      }
    }, {
      key: "checkboxCheckedBg",
      get: function get() {
        return this.bgChecked;
      }
    }, {
      key: "checkboxCheckedHoverBg",
      get: function get() {
        return this.checkboxCheckedBg;
      }
    }, {
      key: "switcherButtonDisabledBorderColor",
      get:
      //#endregion TokenInput
      //#region Switcher
      function get() {
        return this.borderColorDisabled;
      }
    }, {
      key: "fileUploaderBorderColorFocus",
      get: function get() {
        return this.btnBorderColorFocus;
      }
    }, {
      key: "fileUploaderBorderColorError",
      get: function get() {
        return this.borderColorError;
      }
    }, {
      key: "fileUploaderDisabledBg",
      get: function get() {
        return this.btnDisabledBg;
      }
    }, {
      key: "fileUploaderDisabledTextColor",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "fileUploaderDisabledLinkColor",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "fileUploaderDisabledIconColor",
      get: function get() {
        return this.textColorDisabled;
      }
    }, {
      key: "validationsTextColorError",
      get:
      //#endregion FileUploader

      //#region react-ui-validations
      function get() {
        return this.errorText;
      }

      //#endregion
    }]);
  }(BasicThemeClassForExtension), _DarkTheme5_.grayXLight = '#313131', _DarkTheme5_.gray = 'rgba(255, 255, 255, 0.48)', _DarkTheme5_.grayDark = '#e1e1e1', _DarkTheme5_.green = '#23A14A', _DarkTheme5_.greenDark = '#1C8A3F', _DarkTheme5_.red = '#FE4C4C', _DarkTheme5_.redDark = '#DD3333', _DarkTheme5_.yellowXxLight = '#ffe0c3', _DarkTheme5_.yellow = '#ffa236', _DarkTheme5_.yellowDark = '#ea7324', _DarkTheme5_.warningMain = '#ffa236', _DarkTheme5_.errorText = '#FE6C6C', _DarkTheme5_.errorSecondary = '#AB0D0D', _DarkTheme5_.borderColorFocusLight = '#1260ae', _DarkTheme5_.borderColorGrayLight = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.borderColorDisabled = 'rgba(0, 0, 0, 0.10)', _DarkTheme5_.placeholderColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.placeholderColorLight = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.textColorDefault = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.textColorDisabled = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.textColorDisabledContrast = 'rgba(255, 255, 255, 0.48)', _DarkTheme5_.textColorInvert = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.bgDisabled = '#434343', _DarkTheme5_.bgDefault = '#1f1f1f', _DarkTheme5_.bgSecondary = '#333333', _DarkTheme5_.bgChecked = '#EBEBEB', _DarkTheme5_.outlineColorFocus = '#EBEBEB', _DarkTheme5_.borderColorFocus = '#EBEBEB', _DarkTheme5_.fixedPanelShadow = 'none', _DarkTheme5_.closeBtnIconColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.clearCrossIconColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.clearCrossIconHoverColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.linkColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.linkHoverColor = '#ffffff', _DarkTheme5_.linkActiveColor = '#c2c2c2', _DarkTheme5_.linkGrayedColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.linkGrayedHoverColor = '#FFFFFF', _DarkTheme5_.linkGrayedActiveColor = '#C2C2C2', _DarkTheme5_.linkSuccessColor = '#46CD68', _DarkTheme5_.linkSuccessHoverColor = '#67D881', _DarkTheme5_.linkDangerHoverColor = '#FE8C8C', _DarkTheme5_.linkFocusOutlineColor = '#EBEBEB', _DarkTheme5_.linkHoverTextDecoration = 'none', _DarkTheme5_.btnFocusShadowWidth = '2px', _DarkTheme5_.btnOutlineColorFocus = '#1f1f1f', _DarkTheme5_.btnInsetColor = '#1f1f1f', _DarkTheme5_.btnDefaultBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnDefaultHoverBg = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.btnDefaultActiveBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnDefaultHoverBgStart = 'none', _DarkTheme5_.btnDefaultHoverBgEnd = 'none', _DarkTheme5_.btnDefaultBorderColor = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.btnDefaultTextColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.btnSuccessHoverBg = '#26AD50', _DarkTheme5_.btnPrimaryBg = '#EBEBEB', _DarkTheme5_.btnPrimaryBorderColor = '#3D3D3D', _DarkTheme5_.btnPrimaryHoverBg = '#FFFFFF', _DarkTheme5_.btnPrimaryActiveBg = '#C2C2C2', _DarkTheme5_.btnPrimaryActiveBorderColor = '#1261ae', _DarkTheme5_.btnPrimaryTextColor = 'rgba(0, 0, 0, 0.865)', _DarkTheme5_.btnDangerHoverBg = '#ED3F3F', _DarkTheme5_.btnDangerActiveBg = '#DD3333', _DarkTheme5_.btnPayBg = '#FCB73E', _DarkTheme5_.btnPayHoverBg = '#FCC660', _DarkTheme5_.btnPayTextColor = '#222222', _DarkTheme5_.btnPayActiveBg = '#F69912', _DarkTheme5_.btnBacklessBg = 'transparent', _DarkTheme5_.btnBacklessHoverBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnBacklessActiveBg = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.btnBacklessBorderColor = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.btnBacklessDisabledBorderColor = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.btnBacklessHoverBorderColor = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnBacklessTextColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.btnBacklessActiveBorderColor = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnTextBg = 'transparent', _DarkTheme5_.btnTextHoverBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.btnTextActiveBg = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.btnTextBorderColor = 'transparent', _DarkTheme5_.btnWarningSecondary = 'rgba(212, 100, 33, 1)', _DarkTheme5_.btnDisabledBg = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.btnDisabledBorderColor = 'transparent', _DarkTheme5_.btnCheckedBg = '#EBEBEB', _DarkTheme5_.btnCheckedTextColor = 'rgba(0, 0, 0, 0.865)', _DarkTheme5_.btnCheckedDisabledBg = 'rgba(255, 255, 255, 0.32) !important', _DarkTheme5_.btnCheckedDisabledColor = 'rgba(0, 0, 0, 0.48)', _DarkTheme5_.tooltipCloseBtnColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.tooltipCloseBtnHoverColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.tooltipBg = '#333333', _DarkTheme5_.modalBg = '#222', _DarkTheme5_.modalBackBg = '#000', _DarkTheme5_.modalBackOpacity = '0.7', _DarkTheme5_.modalCloseButtonColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.modalCloseButtonHoverColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.modalFooterBg = '#222222', _DarkTheme5_.modalSeparatorBorderBottom = 'solid 1px rgba(255, 255, 255, 0.1)', _DarkTheme5_.sidePageFooterPanelBg = ' #222222', _DarkTheme5_.sidePageBackingBg = '#000', _DarkTheme5_.sidePageBgDefault = '#222', _DarkTheme5_.sidePageBackingBgOpacity = '0.7', _DarkTheme5_.sidePageCloseButtonColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.sidePageCloseButtonHoverColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.selectMenuArrowColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.calendarCellTodayBorder = '1px solid rgba(255, 255, 255, 0.48)', _DarkTheme5_.calendarCellSelectedBgColor = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.calendarMonthTitleBorderBottomColor = 'rgba(255, 255, 255, 0.08)', _DarkTheme5_.calendarCellHoverBgColor = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.calendarCellHoverColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.calendarCellSelectedFontColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.rangeCalendarCellBg = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.rangeCalendarCellHoverBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.rangeCalendarCellEndBg = '#EBEBEB', _DarkTheme5_.rangeCalendarCellEndColor = '#222222', _DarkTheme5_.pagingPageLinkColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.pagingPageLinkHoverBg = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.pagingPageLinkActiveBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.pagingPageLinkDisabledActiveBg = 'rgba(255, 255, 255, 0.08)', _DarkTheme5_.pagingForwardLinkColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.toastLinkColor = 'rgba(44, 44, 44, 1.0)', _DarkTheme5_.toastCloseColor = 'rgba(0, 0, 0, 0.32)', _DarkTheme5_.toastColor = 'rgba(44, 44, 44, 1.0)', _DarkTheme5_.toastBg = 'rgba(255, 255, 255, 0.8)', _DarkTheme5_.toastLinkBgHover = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.toastLinkBgActive = 'rgba(0, 0, 0, 0.16)', _DarkTheme5_.toastCloseHoverColor = 'rgba(0, 0, 0, 0.87)', _DarkTheme5_.tabColorHover = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.menuItemTextColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.menuItemHoverBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.menuItemSelectedBg = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.menuItemCommentColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.menuItemCommentOpacity = '1', _DarkTheme5_.menuSeparatorBorderColor = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.toggleBorderColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.toggleBaseBg = 'none', _DarkTheme5_.toggleOutlineColorFocus = '#1F1F1F', _DarkTheme5_.toggleContainerBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.toggleContainerBoxShadow = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleHandleBg = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.toggleHandleBoxShadow = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleBgHover = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.toggleContainerBoxShadowHover = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleHandleBgHover = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.toggleHandleBoxShadowHover = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleBgChecked = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.toggleContainerBoxShadowChecked = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleHandleBgChecked = '#EBEBEB', _DarkTheme5_.toggleHandleBoxShadowChecked = 'none', _DarkTheme5_.toggleContainerBoxShadowCheckedHover = 'inset 0 0 0 1px rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleHandleBgCheckedHover = '#FFFFFF', _DarkTheme5_.toggleHandleBoxShadowCheckedHover = 'none', _DarkTheme5_.toggleDisabledHandleBg = '#525252', _DarkTheme5_.toggleContainerBgDisabled = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.toggleContainerBoxShadowDisabled = 'none', _DarkTheme5_.toggleHandleBgDisabled = 'rgba(0, 0, 0, 0.16)', _DarkTheme5_.toggleHandleBoxShadowDisabled = 'none', _DarkTheme5_.toggleContainerBgDisabledChecked = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.toggleContainerBoxShadowDisabledChecked = 'none', _DarkTheme5_.toggleHandleBgDisabledChecked = 'rgba(0, 0, 0, 0.16)', _DarkTheme5_.toggleHandleBoxShadowDisabledChecked = 'none', _DarkTheme5_.toggleBgDisabledChecked = 'rgba(255, 255, 255, 0.48)', _DarkTheme5_.tokenShadowDisabled = '', _DarkTheme5_.tokenBorderColorDisabled = 'transparent', _DarkTheme5_.tokenColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.tokenBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.tokenBorderColor = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.tokenColorHover = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.tokenBgHover = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.tokenBorderColorHover = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.tokenColorActive = 'rgba(0, 0, 0, 0.87)', _DarkTheme5_.tokenBgActive = '#EBEBEB', _DarkTheme5_.tokenBorderColorActive = 'transparent', _DarkTheme5_.inputBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.inputColorScheme = 'dark', _DarkTheme5_.inputBlinkColor = '#EBEBEB', _DarkTheme5_.inputTextColor = 'rgba(255, 255, 255, 0.865)', _DarkTheme5_.inputBorderColor = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.inputBackgroundClip = 'border-box', _DarkTheme5_.inputBorderColorHover = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.inputBorderColorFocus = 'rgba(235, 235, 235, 1)', _DarkTheme5_.inputBorderColorWarning = 'rgba(252, 183, 62, 1)', _DarkTheme5_.inputOutlineWidth = '1px', _DarkTheme5_.inputDisabledBg = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.inputDisabledBorderColor = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.dateSelectMenuItemBgActive = 'rgba(255, 255, 255, 0.06)', _DarkTheme5_.dateSelectMenuItemBgSelected = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.dateInputComponentSelectedBgColor = '', _DarkTheme5_.dateInputComponentSelectedTextColor = '', _DarkTheme5_.hintColor = 'rgba(44, 44, 44, 1.0)', _DarkTheme5_.hintBgColor = 'rgba(255, 255, 255, 0.8)', _DarkTheme5_.loaderBg = 'rgba(51, 51, 51, 0.8)', _DarkTheme5_.globalLoaderColor = 'rgba(238, 80, 66, 1)', _DarkTheme5_.passwordInputVisibilityIconOpacity = '1', _DarkTheme5_.radioBgColor = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.radioBorderColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.radioFocusShadow = 'inset 0 0 0 1px rgba(0, 0, 0, 0.87)', _DarkTheme5_.radioDisabledBg = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.radioDisabledShadow = 'none', _DarkTheme5_.radioCheckedDisabledBulletBg = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.radioCheckedBgColor = '#FFFFFF', _DarkTheme5_.radioCheckedBulletColor = 'rgba(0, 0, 0, 0.87)', _DarkTheme5_.radioCheckedBorderColor = 'transparent', _DarkTheme5_.checkboxBg = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.checkboxCheckedColor = 'rgba(0, 0, 0, 0.87)', _DarkTheme5_.checkboxHoverBg = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.checkboxOutlineColorFocus = 'rgba(0, 0, 0, 0.87)', _DarkTheme5_.checkboxBgDisabled = 'rgba(255, 255, 255, 0.04)', _DarkTheme5_.checkboxShadowDisabled = 'none', _DarkTheme5_.inputDisabledBackgroundClip = 'border-box', _DarkTheme5_.switcherButtonCheckedDisabledShadow = 'none', _DarkTheme5_.fileUploaderBg = 'none', _DarkTheme5_.fileUploaderTextColorDefault = '#fff', _DarkTheme5_.fileUploaderBorderColor = 'rgba(255, 255, 255, 0.32)', _DarkTheme5_.fileUploaderLinkColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.fileUploaderIconColor = 'rgba(255, 255, 255, 0.87)', _DarkTheme5_.fileUploaderIconHoverColor = 'rgba(255, 255, 255, 0.80)', _DarkTheme5_.fileUploaderBorderColorWarning = '#ffa236', _DarkTheme5_.fileUploaderDisabledBorderColor = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.fileUploaderUploadButtonBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.fileUploaderHoveredBg = 'rgba(255, 255, 255, 0.16)', _DarkTheme5_.fileUploaderActiveBg = 'rgba(255, 255, 255, 0.1)', _DarkTheme5_.fileUploaderAfterLinkColor = 'rgba(255, 255, 255, 0.54)', _DarkTheme5_.fileUploaderDragOverShadow = '0px 0px 0px 4px #EBEBEB', _DarkTheme5_.validationsTextColorWarning = '#fdd481', _DarkTheme5_),
  prototypeTheme: BasicTheme,
  themeMarkers: [markAsDarkTheme, markThemeVersion('5.0')]
});